import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginModalComponent } from './login.component';
import { defs } from '../../defs';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class LoginModalService {
	constructor(
		private dialog: MatDialog,
		private router: Router,
		private log: NGXLogger) {}

	open(): void {
		const dialogRef = this.dialog.open(LoginModalComponent, {
			width: '350px'
		});

		localStorage.setItem(defs.previousUrl, this.router.url);

		dialogRef.afterClosed().subscribe(result => {
			this.log.trace('LoginModalService: The dialog was closed');
		});
	}
}
